<template>
  <v-row class="pa-0 ma-0">
    <v-col cols="12" class="pa-0">
      <v-card flat color="transparent">
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="4" class="py-0">
              <v-select
                :items='tempGroups'
                label='教室'
                v-model='group'
                hide-details
                item-text="name"
                item-value="key"
              ></v-select>
            </v-col>
            <v-col cols="2" class="py-0">
              <template v-if="checkPrivileges('edit')">
                <v-select
                  :items="extension == 1 ? typesExtension : types"
                  label="種別"
                  hide-details
                  v-model="status"
                  item-text="name"
                  item-value="key"
                ></v-select>
              </template>
            </v-col>
            <v-col cols="3" class="pt-5 pb-0">
              <v-chip depressed outlined small color="primary">{{ num }}</v-chip>
            </v-col>
            <v-col cols="3" class="py-0">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="名前検索"
                hide-details
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <app-students-list
          :tempGroups="tempGroups"
          :status="status"
          :search="search"
          :selects="null"
          :group="group"
          @onSelect="onSelect"
          @onUpdateNumber="onUpdateNumber"
          :type="type"
          :contentsHeight="contentsHeight"
        >
        </app-students-list>
      </v-card>
    </v-col>

    <div>
      <v-dialog v-model="studentDialog"
        hide-overlay
        fullscreen
        transition="dialog-bottom-transition"
        scrollable
        >
        <app-student-dialog
          v-if="studentDialog"
          @dismissed="onDismissed"
          :dialog='studentDialog'
          :item="item"
          :type="checkPrivileges('edit') ? 'edit' : 'view'"
        >
        </app-student-dialog>
      </v-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>
  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import SList from '../../components/student/List.vue'
Vue.component('app-students-list', SList)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      scholae: 'scholae/scholae',
      students: 'students/students',
      windowSize: 'shared/windowSize',
      extension: 'shared/extension'
    }),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 48 - 44 - 40) + 'px;'
    }
  },
  props: [ 'type' ],
  data () {
    return {
      loading: false,
      studentDialog: false,
      item: null,
      tempGroups: [],
      group: '*',
      search: null,
      num: 0,
      types: [
        { name: '在籍', key: 1 },
        { name: '新規', key: 2 },
        { name: '退塾', key: 3 },
        { name: '逸失', key: 4 }
      ],
      typesExtension: [
        { name: '在籍', key: 1 },
        { name: '新規', key: 2 },
        { name: '退会', key: 3 },
        { name: '逸失', key: 4 }
      ],
      status: 1
    }
  },
  watch: {
    groups () {
      this.createGroups()
    },
    data () {
      this.createGroups()
    },
    students () {
      if (this.studentDialog) {
        for (var i in this.students) {
          if (this.item && this.item.key === this.students[i].key) {
            this.item = JSON.parse(JSON.stringify(this.students[i]))
          }
        }
      }
    }
  },
  created () {
    this.createGroups()
  },
  methods: {
    createGroups () {
      this.tempGroups = []
      if (!this.data) {
        return
      }
      if (this.getPrivilegesLevel(this.data) < 2) {
        this.tempGroups.push({ name: '全校', key: '*' })
      }

      this.school = this.getPrimary()

      if (this.checkPrimary()) {
        if (this.data.order) {
          for (var i in this.data.order) {
            var index = this.groups.findIndex(group => group.key === this.data.order[i])
            if (index !== -1) {
              if (this.groups[index].enable && this.groups[index].classroom) {
                this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
              }
            }
          }
        } else {
          var keys = Object.keys(this.data.groups)
          for (i in keys) {
            if (this.data.groups[keys[i]]) {
              index = this.groups.findIndex(g => g.key === keys[i])
              if (index !== -1) {
                if (this.groups[index].enable && this.groups[index].classroom) {
                  this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
                }
              }
            }
          }
        }
        if (this.tempGroups.length !== 0) {
          if (typeof this.data.primaryGroup === 'undefined' || this.data.primaryGroup === null) {
            this.group = this.group1 = this.group2 = this.group3 = this.tempGroups[0].key
          } else {
            for (var x in this.tempGroups) {
              if (this.tempGroups[x].key === this.data.primaryGroup) {
                this.group = this.group1 = this.group2 = this.group3 = this.data.primaryGroup
                break
              }
            }
          }
        } else {
          this.group = null
        }
      } else if (this.school !== null) {
        keys = Object.keys(this.school.groups)
        for (i in keys) {
          if (this.school.groups[keys[i]]) {
            index = this.groups.findIndex(g => g.key === keys[i])
            if (index !== -1) {
              if (this.groups[index].enable && this.groups[index].classroom) {
                this.tempGroups.push(JSON.parse(JSON.stringify(this.groups[index])))
              }
            }
          }
        }
        if (this.tempGroups.length !== 0) {
          this.group = this.group1 = this.group2 = this.group3 = this.tempGroups[0].key
        } else {
          this.group = null
        }
      }
    },
    onChangeItem: function (value) {
      if (this.type && this.type === 'dialog') {
        this.$emit('change', { item: value.item })
      }
    },
    onSelect: function (item) {
      var index = this.students.findIndex(student => student.key === item.key)
      if (index !== -1) {
        this.item = JSON.parse(JSON.stringify(this.students[index]))
        if (this.type && this.type === 'dialog') {
          this.$emit('change', { item: this.item })
        } else {
          this.studentDialog = true
        }
      }
    },
    onUpdateNumber: function (item) {
      this.num = item
    },
    onDismissed () {
      this.studentDialog = false
    }
  }
}
</script>

<style scoped>
</style>
